module.exports = __webpack_public_path__ + "img/logo.4b88b62c.png";